import { PilotId } from '~/eds/src/types/PilotId';
import { BulkEditFieldType } from '~/features/document-bulk-actions/types';
import { pilot } from '~/services/serviceInstances';

type Field = {
  id: PilotId;
  keepOldValues: boolean;
  value: string | string[] | number;
};

interface Request {
  type: BulkEditFieldType;
  documentIds?: PilotId[];
  searchQuery?: object;
  searchAPI: 'v2' | 'v3';
  isAllSelected?: boolean;
  /** Used when type is 'delete' */
  fieldIds?: PilotId[];
  /** Used when type is 'add/replace' */
  fieldUpdates?: Field[];
}

type Params = {
  type: BulkEditFieldType;
  document_ids?: PilotId[];
  query?: object;
  field_ids?: PilotId[];
  field_updates?: {
    id: PilotId;
    value: string | string[] | number;
    keep_old_values: boolean;
  }[];
};
export const documentBulkEditFields = (
  request: Request,
): Promise<{ detail: string }> =>
  pilot.post('document/bulk-edit-field/', mapRequestToParams(request));

const mapRequestToParams = ({
  type,
  documentIds,
  fieldIds,
  fieldUpdates,
  searchQuery,
  searchAPI,
  isAllSelected,
}: Request): Params => ({
  document_ids: !isAllSelected && documentIds ? documentIds : [],
  field_ids: fieldIds,
  field_updates: fieldUpdates?.map(({ id, keepOldValues, value }) => ({
    id,
    value,
    keep_old_values: keepOldValues,
  })),
  ...(isAllSelected
    ? searchAPI === 'v3'
      ? { query_v3: searchQuery }
      : { query: searchQuery }
    : undefined),
  type,
});
